import { render, staticRenderFns } from "./v-chart-legend.vue?vue&type=template&id=06337f45"
import script from "./v-chart-legend.vue?vue&type=script&lang=js"
export * from "./v-chart-legend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06337f45')) {
      api.createRecord('06337f45', component.options)
    } else {
      api.reload('06337f45', component.options)
    }
    module.hot.accept("./v-chart-legend.vue?vue&type=template&id=06337f45", function () {
      api.rerender('06337f45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/chart/v-chart-legend.vue"
export default component.exports